/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// Define the initial state
const initialState = {
  rows: [],
  searchTerm: "",
  status: "idle",
  error: null,
};

// Define the async thunk to fetch rows
export const fetchRows = createAsyncThunk("dashboard/fetchRows", async () => {
  try {
    // Fetch rows from your data source
    const response = await fetch("/api/rows"); // Replace with your actual API endpoint
    const data = await response.json();
    return data.rows;
  } catch (error) {
    throw new Error("Error fetching rows");
  }
});

// Create the dashboard slice
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRows.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchRows.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload;
      })
      .addCase(fetchRows.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

// Export actions and selectors
export const { setSearchTerm } = dashboardSlice.actions;

export const selectRows = (state) => state.dashboard.rows;
export const selectSearchTerm = (state) => state.dashboard.searchTerm;

// Export the reducer
export default dashboardSlice.reducer;
